export default {
      id: "vt-reverse-usage",
      viewBox: "0 0 22 42",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#vt-reverse",
      toString: function () {
        return this.url;
      }
    }